import { Button, Col, Form, Input, Row, Select, Spin, Switch } from 'antd';
import React, { useContext, useEffect, useState } from 'react';
import ReactQuill from 'react-quill';
import { useParams } from 'react-router-dom';
import styled from 'styled-components';
import axiosInstance from '../../../../../../../axios_instance';
import {
  IsAdminContext,
  NumberOfProjectsContext,
  UserProjectsDataContext,
} from '../../../../../../../context';
import { errorHandling } from '../../../../../../../utils/helper';
import { SelectStringInput } from '../../../../../select-input';
import { ISkill } from '../add-project';
import styles from './styles.module.scss';

const StyledSelectStringInput = styled(SelectStringInput)`
  .ant-select-selector {
    background-color: #f6f7fc !important;
    border: none !important;
  }
  border-bottom: 1px solid #d5d5d5;
`;

interface EditProjectProps {
  project_id: number;
  project_name: string;
  company_name: string;
  contribution: string;
  description: string;
  technology: any;
  end_date: string;
  start_date: string;
  setIsEditable: any;
  show_in_resume: boolean;
  companyOptions: any;
}

const EditProject: React.FC<EditProjectProps> = ({
  project_id,
  project_name,
  company_name,
  contribution,
  technology,
  description,
  end_date,
  start_date,
  setIsEditable,
  show_in_resume,
  companyOptions,
}) => {
  //consume Project list from context.
  const [ProjectValue, setProjectValue] = useState<number>(project_id);
  const { userProjectData, setUserProjectData } = useContext(
    UserProjectsDataContext
  );
  const [errorMessage, setErrorMessage] = useState<any>({});
  //If user makes any change then submit state will be true.
  const [allowSubmit, setAllowSubmit] = useState<boolean>(false);
  const isAdmin = useContext(IsAdminContext);
  //This url query parameter will be available for admin user
  const { employeeId } = useParams();
  const [isSubmitted, setIsSubmitted] = useState<boolean>(false);
  const [message, setMessage] = useState<string>();
  const { numberOfProjects, setNumberOfProjects } = useContext(
    NumberOfProjectsContext
  );

  const [showInResume, setShowInResume] = useState(show_in_resume);
  console.log('edit, contribution', contribution);

  const handleChangeResume = (value: any) => {
    setShowInResume(value);
  };
  const handleSave = (values: any) => {
    setIsSubmitted(true);
    if (values.technology !== undefined) {
      if (values.technology && values.technology.length) {
        const technologyObjects = values.technology
          .map((techId: any) => {
            const skill = skills.find(
              (skill) => skill.skill_id === parseInt(techId)
            );
            return skill
              ? { skill_id: skill.skill_id, skill_name: skill.skill_name }
              : null;
          })
          .filter(Boolean);
        values.technology = technologyObjects;
      } else {
        values.technology = [];
      }
    }
    // Condition to check if any changes were made
    if (project_id) {
      values.project_id = project_id;
      values.show_in_resume = showInResume;
      let url = '';
      if (isAdmin === '1') {
        url = '/api/v1/admin/profile/projects';
        values.profile_id = employeeId;
      } else {
        url = '/api/v1/profile/projects';
      }
      axiosInstance
        .post(url, values)
        .then((response) => {
          const userProjects = response.data.projects.filter(
            (Project: any) => Project['status']['id'] === 1
          );
          const orderedProjects = response.data.order && response.data.order.length > 0
            ? response.data.order
                .map((projectId: number) =>
                  userProjects.find((userProject: any) => userProject.project_id === projectId)
                )
                .filter((item: any) => item !== undefined)
            : userProjects;
          setUserProjectData(orderedProjects);
          setIsEditable(false);
          setNumberOfProjects(orderedProjects.length);
        })
        .catch((error) => {
          errorHandling(error, setErrorMessage);
        })
        .finally(() => {
          setIsSubmitted(false);
        });
    } else {
      setIsEditable(false);
    }
  };

  useEffect(() => {
    if (
      userProjectData.find((data: any) => data.Project_id === ProjectValue) &&
      project_id !== ProjectValue
    ) {
      setMessage('The Project already exists.');
    } else {
      setMessage('');
    }
  }, [ProjectValue]);

  const [skills, setSkills] = useState<ISkill[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  useEffect(() => {
    let url = '';
    url = '/api/v1/skills';
    axiosInstance
      .get(url)
      .then((response) => {
        const coreSkills = response.data.skills.filter(
          (skill: ISkill) => skill.skill_type.name === 'core_skill'
        );
        setSkills(coreSkills);
      })
      .catch((error) => {
        setMessage("Something went wrong!Items couldn't be loaded!");
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, []);

  const skillOptions: any =
    skills &&
    skills.map((skill) => ({
      label: skill.skill_name,
      value: String(skill.skill_id),
    }));

  return (
    <div>
      <Form onFinish={handleSave} scrollToFirstError>
        <Row gutter={4} className={styles.row}>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '10px',
              position: 'absolute',
              bottom: '8px',
              right: '8px',
            }}
          >
            <Switch
              defaultChecked={show_in_resume}
              onChange={handleChangeResume}
            />
            <span>Show in resume</span>
          </div>
          <Col span={12}>
            <p>
              <span className={styles.title}>Project Name : </span>
              <Form.Item name="project_name">
                <Input
                  defaultValue={project_name}
                  placeholder="Enter Project Name"
                />
              </Form.Item>
            </p>
          </Col>
          <Col span={12}>
            <p>
              <span className={styles.title}>Technology : </span>
              <Form.Item
                name="technology"
                initialValue={
                  (() => {
                    if (!technology || !Array.isArray(technology)) {
                      return undefined;
                    }
                    const filtered = technology
                      .filter((tech: any) => tech && tech.skill_id != null)
                      .map((tech: any) => String(tech.skill_id));
                    return filtered.length > 0 ? filtered : undefined;
                  })()
                }
              >
                <Select
                  mode="multiple"
                  placeholder="Select Technology"
                  options={skillOptions}
                  showSearch
                  filterOption={(input: string, option: any) =>
                    option &&
                    (option.label as string)
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                />
              </Form.Item>
            </p>
          </Col>
          <Col span={12} style={{ paddingBottom: '40px' }}>
            <p>
              <span className={styles.title}>Description : </span>
              <Form.Item name="description" initialValue={description}>
                <ReactQuill
                  theme="snow"
                  placeholder="Enter description"
                  style={{ height: '150px' }}
                  defaultValue={description}
                  className={styles.inputTextArea}
                />
              </Form.Item>
            </p>
          </Col>
          <Col span={12} style={{ paddingBottom: '40px' }}>
            <p>
              <span className={styles.title}>My Contribution : </span>
              <Form.Item name="contribution" initialValue={contribution}>
                <ReactQuill
                  theme="snow"
                  placeholder="Enter contribution"
                  style={{ height: '150px' }}
                  defaultValue={contribution}
                  className={styles.inputTextArea}
                />
              </Form.Item>
            </p>
          </Col>
          <Col span={12}>
            <p>
              <span className={styles.title}>Company : </span>
              <Form.Item name="company_name">
                <Select
                  placeholder="Select Company"
                  defaultValue={company_name}
                  optionLabelProp="label"
                  options={companyOptions}
                />
              </Form.Item>
            </p>
          </Col>

          <Col span={12}>
            <Row gutter={[10, 10]}>
              <Col span={12}>
                <p>
                  <span className={styles.title}>Start Date : </span>
                  <Form.Item name="start_date">
                    <Input defaultValue={start_date} type="date" />
                  </Form.Item>
                </p>
              </Col>
              <Col span={12}>
                <p>
                  <span className={styles.title}>End Date : </span>
                  <Form.Item name="end_date">
                    <Input defaultValue={end_date} type="date" />
                  </Form.Item>
                </p>
              </Col>
            </Row>
          </Col>
        </Row>
        <Row>
          {isSubmitted ? <Spin /> : <></>}
          <Form.Item style={{ float: 'right', marginLeft: 'auto' }}>
            <Button
              className={styles['save-button']}
              type="primary"
              htmlType="submit"
              style={{ float: 'right', marginLeft: 'auto', marginRight: '0px' }}
              // disabled={
              //   !ProjectValue
              // }
            >
              Save
            </Button>
          </Form.Item>

          <Button
            className={styles['cancel-button']}
            style={{ marginRight: '0px' }}
            onClick={(e) => {
              setIsEditable(false);
            }}
          >
            Cancel
          </Button>
        </Row>
      </Form>
    </div>
  );
};

export default EditProject;
